import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import cs from './locales/cs.json';
import en from './locales/en.json';

void i18next.use(initReactI18next).init({
  lng: localStorage.getItem('lng') || 'cs',
  fallbackLng: 'cs',
  debug: false,
  resources: { en, cs },
  interpolation: {
    escapeValue: false,
  },
});

export default i18next;
